import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import { Link } from 'react-router-dom';
import { withRouter } from '../../../util/withRouter';
import { Button } from 'react-bootstrap';

import { handleError, registerUser } from '../AuthActions';
import Testimonial from '../components/Testimonial/Testimonial';
import { PAGES, trackPageView } from '../../../util/mixpanel';

import logo from './img/logo-nave-icon.svg';

// Import Style
import '../Auth.scss';

class RegisterPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      name: '',
    };
  }

  handleChange = (ev) => {
    this.setState({
      [ev.target.name]: ev.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.email) {
      this.props.setError({
        data: {
          email: {
            msg: 'error.email.empty',
          },
        },
      });
      return false;
    }

    if (!this.state.name) {
      this.props.setError({
        data: {
          name: {
            msg: 'error.name.empty',
          },
        },
      });
      return false;
    }

    if (!this.state.password) {
      this.props.setError({
        data: {
          password: {
            msg: 'error.password.empty',
          },
        },
      });
      return false;
    }

    this.props
      .register({
        email: this.state.email,
        name: this.state.name,
        password: this.state.password,
        iid: this.props.location.query.iid,
        uid: this.props.location.query.uid,
        referral: this.props.location.query.referral,
      })
      .then(
        () => {
          this.props.router.replace(`/login${this.props.location.search}`);
        },
        (err) => {}
      );
  };

  render() {
    trackPageView(PAGES.REGISTER);

    return (
      <div className='login_bg'>
        <Helmet>
          <title>{pageTitle('Register')}</title>
          <link rel="alternate" href={`https://${this.props.app}.getnave.com`} hrefLang="en-us" />
        </Helmet>
        <div className={`login_form ${this.props.app}`}>
          <div className='logo'>
            <img src={logo} alt="" />
          </div>
          <div className='login_content'>
            <div className='left_part'>
              <h1>Create your Nave account</h1>
              <p className="mb-4">Import your data using JSON or CSV files.</p>
              <form className='form' noValidate onSubmit={this.handleSubmit}>
                <div className='form_container'>
                  <label>Name</label>
                  <input
                    autoFocus
                    className='form-control'
                    name="name"
                    type="text"
                    id="name"
                    value={this.state.name}
                    onChange={this.handleChange}
                  />
                </div>
                <div className='form_container'>
                  <label>Email</label>
                  <input
                    autoFocus
                    className='form-control'
                    name="email"
                    type="email"
                    id="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                  />
                </div>
                <div className='form_container'>
                  <label>Password</label>
                  <input
                    autoFocus
                    className='form-control'
                    type={this.state.show ? 'text' : 'password'}
                    name="password"
                    id="password"
                    value={this.state.password}
                    onChange={this.handleChange}
                  />
                </div>
                <Button variant="primary" type="submit" className="mt-5">
                  Register
                </Button>
                <p className='link_account'>
                  Already have an account? <Link to={`/login${this.props.location.search}`}>Log in</Link>
                </p>
              </form>
            </div>
            <div className='right_part'>
              <h3>Nave is trusted by 7,000+ agile teams</h3>
              <Testimonial />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RegisterPage.propTypes = {
  intl: intlShape.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    register: (body) => dispatch(registerUser(body)),
    setError: (err) => dispatch(handleError(err)),
  };
};

function mapStateToProps(state) {
  return {
    app: state.app.app,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(RegisterPage)));
